//import Libraries
import React, {Component} from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

//import Components
import Agreements from '../Agreements/Agreements';
import SignIn from  '../SignIn/SignIn';
import SignUp from '../SignUp/SignUp';
import NotLoggedIn from '../NotLoggedIn/NotLoggedIn';
import UpdateUserInfo from '../UpdateUserInfo/UpdateUserInfo';
import ResetPassword from '../ResetPassword/ResetPassword';
import Withdraw from '../Withdraw/Withdraw';
import Language from '../../language/language.json';
import Dropdown from './Dropdown/Dropdown';
import Icons from '../../assets/icons/icons';

import SimpleModal from '../SimpleModal/SimpleModal';

import * as navigationActions from './actions/navigationActions';
import * as modalActions from './actions/modalActions';
import * as storeActions from '../../pages/Store/actions/storeActions';

//import Style classes
import './Navigation.css';

const loginIcon = Icons.login;
const storeIcon = Icons.store;

class Navigation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openMediaNav: false
        }
    }

    toggleMediaNav = () => {
        this.setState(prevState => ({
            openMediaNav : !prevState.openMediaNav
        }))
    }

    render() {
        const { language } = this.props.universal;
        const { login } = this.props.user;
        const {simpleStore} = this.props;

        let relativeBool = this.props.relative ? "relative" : "";
        let logo = ( <img 
                        src={require('../../assets/logo/logo-main-ko.svg')}
                        className="Logo"
                        alt=""/> )
        if(language === 'en')
        {
            logo = ( <img 
                        src={require('../../assets/logo/logo-main-en.svg')}
                        className="Logo"
                        alt=""/> )
        }

        let storeButton = 
        <li className="StoreButton">
            {storeIcon}
            <Link to='/store'>{Language.nav.store[language]}</Link>
        </li>

        let adjustableNav = 
        <React.Fragment>
            {Language.newNav.map((obj, idx)=> {return <Dropdown data={obj} key={idx} lang={language}/>})}
            {storeButton}
        </React.Fragment>

        let storeNav = 
            <React.Fragment>
                <li><Link to='/'>{Language.storeCommon.home[language]}</Link></li>
                {storeButton}
                <li className={simpleStore ? "SimpleBtn" : "NormalBtn"}
                    onClick={this.props.onToggleSimpleStore}>
                    {Language.storeCommon.simpleStore[language]}
                </li>
            </React.Fragment>
        
        let loginButton = 
        login ? (
            <li className="LoginButton LoggedIn"> 
                <Link to='/mypage'> 
                {loginIcon}
                {this.props.user.fullName + "님"} </Link>
            </li>
        ) : (
            <li className="LoginButton" onClick={() => this.props.onToggleModal('signIn')}>
                {loginIcon}
                {Language.nav.signIn[language]}
            </li>
        )

        return (
            <div className={'Navigation '+relativeBool}>
                <div className="HomeTitle">
                    <Link to='/'>
                        <img src={require('../../assets/logo/logo-main-ko-red.svg')}
                            className="Logo"
                            alt=""/>
                    </Link>
                    {/* <div id="Language" onClick={this.props.onChangeLanguage}> <p>EN / KR</p> </div> */}
                </div>
                <nav>
                    <ul>
                        {this.props.isStore ? null : adjustableNav}
                        {this.props.isStore ? storeNav : null}
                        {loginButton}
                    </ul>
                </nav>
                <div className="MediaNavButton" onClick={this.toggleMediaNav}>
                    {Icons.menu}
                </div>
                <div className={this.state.openMediaNav ? "MediaNav open" : "MediaNav"}>
                    <div className="BackDrop" onClick={this.toggleMediaNav}></div>
                    <nav>
                        <ul>
                            {this.props.isStore ? null : adjustableNav}
                            {this.props.isStore ? storeNav : null}
                            {loginButton}
                        </ul>
                    </nav>
                </div>

                <Agreements
                    modal={this.props.modals.agreements}
                    toggle={() => this.props.onToggleModal('agreements')}
                    onAgreeClick={()=>{
                        this.props.onToggleModal('agreements');
                        this.props.onToggleModal('signUp');
                    }}
                />
                <SignIn 
                    modal={this.props.modals.signIn}
                    toggle={() => this.props.onToggleModal("signIn")}
                    onSignUpClick={() => {
                        this.props.onToggleModal('signIn');
                        this.props.onToggleModal('agreements');
                    }}
                    onResetClick={() => {
                        this.props.onToggleModal('signIn');
                        this.props.onToggleModal('reset');
                    }}
                />
                <SignUp 
                    modal={this.props.modals.signUp}
                    toggle={() => this.props.onToggleModal('signUp')}
                />
                <ResetPassword 
                    modal={this.props.modals.reset}
                    toggle={() => this.props.onToggleModal('reset')}
                />
                <NotLoggedIn 
                    modal={this.props.modals.notLoggedIn}
                    toggle={() => this.props.onToggleModal('notLoggedIn')}
                    onToSignInClick={() => {
                        this.props.onToggleModal('notLoggedIn');
                        this.props.onToggleModal('signIn');
                    }}
                    onToSignUpClick={() => {
                        this.props.onToggleModal('notLoggedIn');
                        this.props.onToggleModal('signUp')
                    }}
                />
                <SimpleModal 
                    modal={this.props.modals.notVerified}
                    toggle={() => this.props.onToggleModal('notVerified')}
                    title={Language.modal.notVerified.title[language]}
                    content={`${Language.modal.notVerified.front[language]}${this.props.user.email}${Language.modal.notVerified.back[language]}`}
                    buttonValue={Language.modal.notVerified.button[language]}
                />
                {/* { 확인 이메일 관련} */}
                <SimpleModal 
                    modal={this.props.modals.verificationEmailSent}
                    toggle={() => this.props.onToggleModal('verificationEmailSent')}
                    title={Language.modal.verificationEmailSent.title[language]}
                    content={`${Language.modal.verificationEmailSent.front[language]}${this.props.user.email}${Language.modal.verificationEmailSent.back[language]}`}
                    buttonValue={Language.modal.verificationEmailSent.button[language]}
                />
                <SimpleModal 
                    modal={this.props.modals.verificationEmailSentFail}
                    toggle={() => this.props.onToggleModal('verificationEmailSentFail')}
                    title={Language.modal.verificationEmailSentFail.title[language]}
                    content={Language.modal.verificationEmailSentFail.content[language]}
                    buttonValue={Language.modal.verificationEmailSentFail.button[language]}
                />
                {/* {정보 업데이트 관련} */}
                <UpdateUserInfo 
                    modal={this.props.modals.updateUserInfo}
                    toggle={() => this.props.onToggleModal('updateUserInfo')}
                    title={Language.modal.updateUserInfo.title[language]}
                    placeholder={Language.modal.updateUserInfo.passwordPlace[language]}
                    buttonValue={Language.modal.updateUserInfo.button[language]}
                />
                <SimpleModal 
                    modal={this.props.modals.userInfoUpdated}
                    toggle={() => this.props.onToggleModal('userInfoUpdated')}
                    title={Language.modal.userInfoUpdated.title[language]}
                    content={Language.modal.userInfoUpdated.content[language]}
                    buttonValue={Language.modal.userInfoUpdated.button[language]}
                />
                <Withdraw 
                    modal={this.props.modals.withdraw}
                    toggle={() => this.props.onToggleModal('withdraw')}
                    title={Language.modal.withdraw.title[language]}
                    content={Language.modal.withdraw.passwordPlace[language]}
                    buttonValue={Language.modal.withdraw.button[language]}
                />
                <SimpleModal 
                    modal={this.props.modals.withdrawSuccess}
                    toggle={() => this.props.onToggleModal('withdrawSuccess')}
                    title={Language.modal.withdrawSuccess.title[language]}
                    content={Language.modal.withdrawSuccess.content[language]}
                    buttonValue={Language.modal.withdrawSuccess.button[language]}
                />
                {/* 콘텍트 피드백 */}
                <SimpleModal 
                    modal={this.props.modals.contactSent}
                    toggle={() => this.props.onToggleModal('contactSent')}
                    title={Language.modal.contactSent.title[language]}
                    content={Language.modal.contactSent.content[language]}
                    buttonValue={Language.modal.contactSent.button[language]}
                />
                {/* 주문 피드백 */}
                <SimpleModal 
                    modal={this.props.modals.orderSent}
                    toggle={() => this.props.onToggleModal('orderSent')}
                    title={Language.modal.orderSent.title[language]}
                    content={Language.modal.orderSent.content[language]}
                    buttonValue={Language.modal.orderSent.button[language]}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        universal: state.universal,
        user : state.user,
        simpleStore : state.store.simpleStore,
        modals : state.modals,
    };
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChangeLanguage : ()=>{
            dispatch(navigationActions.changeLanguage());
        },
        onToggleSimpleStore : () => {
            dispatch(storeActions.toggleSimpleStore());
        },
        onToggleModal : (name) => {
            dispatch(modalActions.toggleModal(name));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);


// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js